import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useThemeMode } from '@core/ThemeContext';

export const ThemeToggle: React.FC = () => {
    const { mode, toggleMode } = useThemeMode();
    const isDark = mode === 'dark';

    return (
        <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
            <IconButton
                onClick={toggleMode}
                size="small"
                sx={{ color: 'inherit', '@media (pointer: coarse)': { minWidth: 44, minHeight: 44 } }}
                aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
            >
                {isDark ? <Brightness7Icon /> : <Brightness4Icon />}
            </IconButton>
        </Tooltip>
    );
};
